/* global gtag_ks_tracking */
$('[data-gtag-track]').on("click", function (e) {

    const el_link = $(this),
        action = el_link.data("gtagTrack"),
        href = el_link.attr("href");

    if (el_link.hasClass("tracked") || typeof gtag_ks_tracking === "undefined") {

        if (el_link.attr("target") === "_blank"){

            window.open(
                href,
                el_link.attr("target")
            );

        }else{

            location.href = href;

        }

        el_link.unbind(e);

    } else {

        if (el_link.hasClass("tracking")) {

            return false;

        }

        // Adblock detector.
        fetch('https://www.googletagmanager.com/gtag/js?id=UA-67281001-34')
            .then(response => {
                if (response.headers.get('Content-Length') === null){
                    location.href = href;
                }
            })
            .catch(error => {
                location.href = href;
            });

        el_link.addClass("tracking");

        gtag_ks_tracking('event', action, {
            event_category: location.origin,
            event_label: href,
            event_callback: function () {

                el_link.addClass("tracked");

                el_link.get(0).click();
            }
        });

        return false;

    }
});
